/**
 * Helpers for displaying download validity info in customer/order tables.
 */

export function formatRemaining(expiryAt) {
  if (!expiryAt) return '-';
  const exp = new Date(expiryAt);
  const now = new Date();
  const ms = exp.getTime() - now.getTime();
  if (isNaN(ms)) return '-';
  if (ms <= 0) return 'Expired';
  const hours = ms / (1000 * 60 * 60);
  if (hours < 1) {
    const mins = Math.max(1, Math.floor(ms / (1000 * 60)));
    return `${mins} min${mins === 1 ? '' : 's'} left`;
  }
  if (hours < 24) {
    const h = Math.floor(hours);
    return `${h} hour${h === 1 ? '' : 's'} left`;
  }
  const days = Math.floor(hours / 24);
  const remH = Math.floor(hours - days * 24);
  if (days < 7) {
    return remH > 0 ? `${days}d ${remH}h left` : `${days} day${days === 1 ? '' : 's'} left`;
  }
  return `${days} days left`;
}

export function getDownloadStatus(dl) {
  if (!dl) return { label: '-', tone: 'none' };
  if (dl.is_revoked) return { label: 'Revoked', tone: 'danger' };
  if (dl.is_expired) return { label: 'Expired', tone: 'muted' };
  if (dl.is_limit_reached || dl.downloads_remaining === 0) return { label: 'Limit Reached', tone: 'muted' };
  return { label: 'Active', tone: 'success' };
}
